export default class RemoveItems {
  constructor() {
    this.$item = $('#myId');
  }

  pitfalseTextShow() {
    const welcomeText = $('.pitfalls-wrap .pitfalls-h2');
    const item = $('.blog-item').length;
    if (item === 0) {
      welcomeText.css('display', 'none');
    }
  }

  applyItems() {
    const input = $('.logo-input');
    const remove = $('.logo-remove');
    const btn = $('.logo-btn');
    input.css('opacity', '0');
    remove.css('opacity', '0');
    // input.css('pointer-events', 'none');
    remove.css('pointer-events', 'none');
    btn.click(() => {
      input.css('opacity', '1');
      remove.css('opacity', '1');
      input.css('pointer-events', 'auto');
      remove.css('pointer-events', 'auto');
    });
  }
  applyItemsCover() {
    const input = $('.cover-input');
    const remove = $('.cover-remove');
    const btn = $('.cover-btn');
    input.css('opacity', '0');
    remove.css('opacity', '0');
    input.css('pointer-events', 'none');
    remove.css('pointer-events', 'none');
    btn.click(() => {
      input.css('opacity', '1');
      remove.css('opacity', '1');
      input.css('pointer-events', 'auto');
      remove.css('pointer-events', 'auto');
    });
  }


  init() {
    this.pitfalseTextShow();
    this.applyItems();
    this.applyItemsCover();
    // this.add();
    // this.addMultiple();
    // this.addVideoLink();
    // this.removeVideoLink();
    // this.addPodcastLink();
    // this.removePodcastLink();
    // this.addLogoGroup();
    // this.addCoverImageGroup();
  }
}
